import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.articleFlavors.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.articleFlavors.actionsLoading;
export const getItems = (state:RootState) => state.articleFlavors.items;
export const getItemsSelect = (state:RootState) => state.articleFlavors.dropDownItems;
export const getItemsCount = (state:RootState) => state.articleFlavors.itemsCount;
export const getItemForEdit = (state:RootState) => state.articleFlavors.itemForEdit;
export const getError = (state:RootState) => state.articleFlavors.error;
export const getErrorAction = (state:RootState) => state.articleFlavors.errorAction;
export const validationErrors = (state: RootState) => state.articleFlavors.validationErrors;
